import { APIError } from "../../api/utils/errors";

/** The case fetch said this account may not see the case, or it is gone. */
export const isCaseUnavailable = (error: unknown): boolean =>
  error instanceof APIError && (error.status === 403 || error.status === 404);

/** The tab title for a case this account can't open. */
export const NO_ACCESS_TITLE = "No Access";
